import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './contexts/ThemeContext';
import { DataProvider } from './contexts/DataContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { registerInternalFonts } from './utils/registerInternalFonts';
import { Analytics } from '@vercel/analytics/react';

registerInternalFonts();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary fallbackMessage="Co/Plot encountered an unexpected error.">
      <DataProvider>
        <ThemeProvider>
          <NotificationProvider>
            <App />
            <Analytics />
          </NotificationProvider>
        </ThemeProvider>
      </DataProvider>
    </ErrorBoundary>
  </React.StrictMode>
);